import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Fill } from "react-icons/ri";
import Tags from "../Components/Tags";
import { useOutletContext } from "react-router-dom";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import apis from "../api/api";
import * as api from "../api/api";
import Loading from "./Loading";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Snackbar, Alert } from "@mui/material";
import Select from "react-select";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
import cloneDeep from "lodash/cloneDeep";

function ServiceInfo(props) {
  const { servicesResponse, setServicesResponse } = useOutletContext();
  const { language } = useLanguage();
  const pageTitle = "ServiceInfo";
  const [serviceInfo, setServiceInfo] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [ToBeDeletedForm, setToBeDeletedForm] = useState({
    type: "",
    id: "",
  });
  const [modals, setModals] = useState({
    offlineForm: {
      show: false,
      editing: false,
      value: { id: "", label: "" },
      toBeEdited: { id: "", label: "", position: "" },
    },
    inboundForm: {
      show: false,
      editing: false,
      value: { id: "", label: "" },
      toBeEdited: { id: "", label: "", position: "" },
    },
    outboundForm: {
      show: false,
      editing: false,
      value: { id: "", label: "" },
      toBeEdited: { id: "", label: "", position: "" },
    },
  });
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [AvailableForms, setAvailableForms] = useState([]);
  const [allForms, setAllForms] = useState([]);
  const [availableVdns, setAvailableVdns] = useState([]);
  const [selectedVdn, setselectedVdn] = useState([]);
  const [availableOutboundVdns, setAvailableOutboundVdns] = useState([]);
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState({
    show: false,
    message: "",
  });
  const [showInvalidVdnSnackbar, setShowInvalidVdnSnackbar] = useState(false);
  const [inboundVdnOptions, setInboundVdnOptions] = useState([]);
  const [outboundVdnOptions, setOutboundVdnOptions] = useState([]);

  function handleFormSelection(formType, value) {
    console.log("selected value : ", value);
    console.log(modals);

    setModals({
      ...modals,
      [formType]: { ...modals[formType], value: value },
    });
    console.log(modals);
  }

  function handleFetchAvailableForms() {
    setLoading(true);
    api
      .getAllEnabledForms()
      .then((response) => {
        console.log("enabled forms are:", response.data.object);
        setAvailableForms(response.data.object);
        setAllForms(response.data.object);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleFetchInboundForms() {
    setLoading(true);
    api
      .getInboundVdns()
      .then((response) => {
        console.log("vdns are:", response.data.object);
        setAvailableVdns(response.data.object);
        setLoading(false);

        const fetchedOptions = response.data.object.map((item) => ({
          value: item.inboundVdnId,
          label: item.name,
        }));
        setInboundVdnOptions(fetchedOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleFetchOutboundVdns() {
    setLoading(true);
    api
      .getAllOutboundVdns()
      .then((response) => {
        console.log("outbound vdns are:", response.data.object);
        setAvailableOutboundVdns(response.data.object);
        setLoading(false);

        // now, loop through all the services to see if this outbound vdn is assigned to a service already

        const fetchedOptions = response.data.object.map((item) => ({
          value: item.outboundVdnId,
          label: item.name,
        }));
        setOutboundVdnOptions(fetchedOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    setLoading(true);
    handleFetchAvailableForms();
    handleFetchInboundForms();
    handleFetchOutboundVdns();
    setLoading(true);
  }, []);

  const [modifiedUser, setModifiedUser] = useState();

  const params = useParams();
  let location = useLocation();
  useEffect(() => {
    setLoading(true);
    apis.getServiceById(params.id).then((response) => {
      // console.log(response.data.object)

      if (response.data.statusCode == 400 || response.data.statusCode == 500) {
        setShowErrorSnackbar({ show: true, message: response.data.message });
        setLoading(false);
      } else if (response.data.statusCode == 404) {
        setShowErrorSnackbar({ show: true, message: response.data.message });
        setLoading(false);
      } else {
        const newServiceInfo = {
          serviceId: parseInt(params.id),
          ...response.data.object,
        };

        api
          .getUserById(response.data.object.modifiedByUserId)
          .then((response) => {
            setModifiedUser(response.data.object.name);
          });

        setServiceInfo(newServiceInfo);
        setLoading(false);
      }
    });
  }, [location]);

  function sortFormPositions(a, b) {
    if (a.position < b.position) {
      return -1;
    } else if (a.position > b.position) {
      return 1;
    } else {
      return 0;
    }
  }

  function changeFormPosition(id, formType, direction) {
    if (formType === "offlineForm") {
      if (direction === "up") {
        //change position attribute of form in serviceInfo.offlineForms
        let newForms = serviceInfo.offlineForms;
        for (let i = 0; i < newForms.length; i++) {
          if (newForms[i].formId === id && newForms[i].position > 1) {
            newForms[i - 1].position += 1;
            newForms[i].position = newForms[i].position - 1;
            setServiceInfo({ ...serviceInfo, offlineForms: newForms });
          }
        }
      } else if (direction === "down") {
        //change position attribute of form in serviceInfo.offlineForms
        let newForms = serviceInfo.offlineForms;
        for (let i = 0; i < newForms.length; i++) {
          if (
            newForms[i].formId === id &&
            newForms[i].position < newForms.length
          ) {
            newForms[i + 1].position -= 1;
            newForms[i].position = newForms[i].position + 1;
            setServiceInfo({ ...serviceInfo, offlineForms: newForms });
          }
        }
      }
    } else if (formType === "inboundForm") {
      if (direction === "up") {
        //change position attribute of form in serviceInfo.ddiForms
        let newForms = serviceInfo.ddiForms;
        for (let i = 0; i < newForms.length; i++) {
          if (newForms[i].formId === id && newForms[i].position > 1) {
            newForms[i - 1].position += 1;
            newForms[i].position = newForms[i].position - 1;
            setServiceInfo({ ...serviceInfo, ddiForms: newForms });
          }
        }
      } else if (direction === "down") {
        //change position attribute of form in serviceInfo.ddiForms
        let newForms = serviceInfo.ddiForms;
        for (let i = 0; i < newForms.length; i++) {
          if (
            newForms[i].formId === id &&
            newForms[i].position < newForms.length
          ) {
            newForms[i + 1].position -= 1;
            newForms[i].position = newForms[i].position + 1;
            setServiceInfo({ ...serviceInfo, ddiForms: newForms });
          }
        }
      }
    } else if (formType === "outboundForm") {
      if (direction === "up") {
        //change position attribute of form in serviceInfo.offlineForms
        let newForms = serviceInfo.callLineForms;
        for (let i = 0; i < newForms.length; i++) {
          if (newForms[i].formId === id && newForms[i].position > 1) {
            newForms[i - 1].position += 1;
            newForms[i].position = newForms[i].position - 1;
            setServiceInfo({ ...serviceInfo, callLineForms: newForms });
          }
        }
      } else if (direction === "down") {
        //change position attribute of form in serviceInfo.offlineForms
        let newForms = serviceInfo.callLineForms;
        for (let i = 0; i < newForms.length; i++) {
          if (
            newForms[i].formId === id &&
            newForms[i].position < newForms.length
          ) {
            newForms[i + 1].position -= 1;
            newForms[i].position = newForms[i].position + 1;
            setServiceInfo({ ...serviceInfo, callLineForms: newForms });
          }
        }
      }
    }
  }

  function handleAddForm(formType) {
    if (formType === "offlineForm") {
      // compare the already exisiting forms in this service and manipulate the available forms
      // to be the remainder, available = all - existing
      // map them by ids
      const serviceInfoFormsIds = serviceInfo[formType + "s"].map(
        (obj) => obj.formId
      );

      const filteredArray = allForms.filter(
        (obj) => !serviceInfoFormsIds.includes(obj.formId)
      );

      setAvailableForms(filteredArray);
    } else if (formType === "inboundForm") {
      // compare the already exisiting forms in this service and manipulate the available forms
      // to be the remainder, available = all - existing
      // map them by ids
      // let otherFieldName = "ddiForms";
      // const serviceInfoFormsIds = serviceInfo[otherFieldName].map(
      //   (obj) => obj.formId
      // );
      // const filteredArray = AvailableForms.filter(
      //   (obj) => !serviceInfoFormsIds.includes(obj.formId)
      // );
      // console.log(filteredArray);
      // setAvailableForms(filteredArray);
    } else if (formType === "outboundForm") {
      // compare the already exisiting forms in this service and manipulate the available forms
      // to be the remainder, available = all - existing
      // map them by ids
      // let otherFieldName = "callLineForms";
      // const serviceInfoFormsIds = serviceInfo[otherFieldName].map(
      //   (obj) => obj.formId
      // );
      // const filteredArray = AvailableForms.filter(
      //   (obj) => !serviceInfoFormsIds.includes(obj.formId)
      // );
      // console.log(filteredArray);
      // setAvailableForms(filteredArray);
    }

    console.log(formType);
    console.log("modals: ", modals);
    setModals({
      ...modals,
      [formType]: {
        ...modals[formType],
        show: true,
        editing: false,
      },
    });
    console.log("modals: ", modals);
  }
  function handleAddFormToService(formType) {
    console.log(formType);
    if (formType === "offlineForm") {
      if (modals.offlineForm.value) {
        // Your logic here for handling the "OK" button click
        // You can use modals.offlineForm.value for the selected option
        console.log("Selected Form:", modals.offlineForm.value);
        if (modals.offlineForm.value.id == "") {
          setShowErrorSnackbar({
            ...showErrorSnackbar,
            message: strings[pageTitle][language].invalidInfoMessage,
            show: true,
          });
          return;
        }
      }

      const { position } = modals.offlineForm.toBeEdited;
      const { id, label } = modals.offlineForm.value;

      if (modals.offlineForm.editing) {
        let newForm = {
          formId: id,
          formName: label,
          position: position,
        };
        let newForms = serviceInfo.offlineForms.map((form) =>
          form.position !== position ? form : newForm
        );
        console.log("new form to be changed", newForm);
        console.log("newforms for editing : ", newForms);
        setServiceInfo({ ...serviceInfo, offlineForms: newForms });
        handleClose(formType);
      } else {
        //TODO

        // check if selected is already in the list
        let selectedName = label;
        console.log(label);
        let mappedNames = [];
        mappedNames = serviceInfo.offlineForms.map((obj) => obj.formName);

        console.log(mappedNames.includes(selectedName));

        if (mappedNames.includes(selectedName)) {
          // show an error message
          setShowErrorSnackbar({
            show: true,
            message: "Service already has this form included",
          });
          return;
        } else {
          let newForm = {
            formId: id,
            formName: label,
            position: serviceInfo.offlineForms.length + 1,
          };
          let newForms = [...serviceInfo.offlineForms, newForm];
          console.log("newforms for adding : ", newForms);
          setServiceInfo({ ...serviceInfo, offlineForms: newForms });
          handleClose(formType);
        }
      }
    } else if (formType === "inboundForm") {
      if (modals.inboundForm.value) {
        // Your logic here for handling the "OK" button click
        // You can use modals.offlineForm.value for the selected option
        console.log("Selected Form:", modals.inboundForm.value);
        if (modals.inboundForm.value.id == "") {
          setShowErrorSnackbar({
            ...showErrorSnackbar,
            message: strings[pageTitle][language].invalidInfoMessage,
            show: true,
          });
          return;
        }
      }
      console.log(selectedVdn);
      const { position } = modals.inboundForm.toBeEdited;
      const { id, label } = modals.inboundForm.value;
      if (modals.inboundForm.editing) {
        let newForm = {
          formId: id,
          formName: label,
          position: position,
          number: selectedVdn,
        };
        let newForms = serviceInfo.ddiForms;

        // add this "newForm" to the "newForms" which is just an array of forms,
        // while removing the old one (filter it out by looking at the formId)

        function addOrUpdateItem(newItem) {
          const index = newForms.findIndex(
            (item) => item.formId === newItem.formId
          );

          if (index !== -1) {
            // If formId exists, update the existing entry
            newForms[index] = { ...newForms[index], ...newItem };
          } else {
            // If formId doesn't exist, add a new item
            newForms.push(newItem);
          }
        }

        addOrUpdateItem(newForm);

        console.log("new form to be changed", newForm);
        console.log("newforms for editing : ", newForms);
        setServiceInfo({ ...serviceInfo, ddiForms: newForms });
        handleClose(formType);
      } else {
        console.log(selectedVdn);
        let number;
        try {
          number = selectedVdn.map((obj) => obj.value).join(", ");
        } catch (e) {
          number = selectedVdn;
        }

        let newForm = {
          formId: id,
          formName: label,
          number: number,
        };

        console.log(serviceInfo);
        let newForms = [...serviceInfo.ddiForms, newForm];
        console.log("newforms for adding : ", newForms);
        setServiceInfo({ ...serviceInfo, ddiForms: newForms });
        handleClose(formType);
        console.log(serviceInfo.ddiForms);
      }
    } else if (formType === "outboundForm") {
      if (modals.outboundForm.value) {
        // Your logic here for handling the "OK" button click
        // You can use modals.offlineForm.value for the selected option
        console.log("Selected Form:", modals.outboundForm.value);
        if (modals.outboundForm.value.id == "") {
          setShowErrorSnackbar({
            ...showErrorSnackbar,
            message: strings[pageTitle][language].invalidInfoMessage,
            show: true,
          });
          return;
        }
      }
      console.log(selectedVdn);
      console.log(modals.outboundForm);
      const { position } = modals.outboundForm.toBeEdited;
      const { id, label } = modals.outboundForm.value;
      console.log(selectedVdn);
      if (
        selectedVdn == "" ||
        selectedVdn === undefined ||
        selectedVdn.length == 0
      ) {
        console.log("detected");
        setShowInvalidVdnSnackbar(true);
      } else {
        console.log("SELECTED POSITION: ", position);
        if (modals.outboundForm.editing) {
          let newForm = {
            formId: id,
            formName: label,
            position: position,
            name: selectedVdn,
          };
          let newForms = [...serviceInfo.callLineForms];

          // add this "newForm" to the "newForms" which is just an array of forms,
          // while removing the old one (filter it out by looking at the formId)

          function addOrUpdateItem(newItem) {
            const index = newForms.findIndex(
              (item) => item.formId === newItem.formId
            );

            if (index !== -1) {
              // If formId exists, update the existing entry
              newForms[index] = { ...newForms[index], ...newItem };
            } else {
              // If formId doesn't exist, add a new item
              newForms.push(newItem);
            }
          }

          addOrUpdateItem(newForm);

          console.log("new form to be changed", newForm);
          console.log("newforms for editing : ", newForms);

          console.log(newForm);
          console.log(newForms);
          console.log("new form to be changed", newForm);
          console.log("newforms for editing : ", newForms);

          setServiceInfo({ ...serviceInfo, callLineForms: newForms });
          handleClose(formType);
        } else {
          let name;

          try {
            name = selectedVdn.map((obj) => obj.value).join(", ");
          } catch (e) {
            name = selectedVdn;
          }

          let newForm = {
            formId: id,
            formName: label,
            name: name,
          };
          console.log(serviceInfo);
          let newForms = [...serviceInfo.callLineForms, newForm];
          console.log("newforms for adding : ", newForms);
          setServiceInfo({ ...serviceInfo, callLineForms: newForms });
          handleClose(formType);
          console.log(serviceInfo.callLineForms);
        }
      }
    }
  }
  function handleRemoveForm() {
    const { type, id } = ToBeDeletedForm;
    if (type === "offlineForm") {
      console.log(ToBeDeletedForm);
      console.log("old forms are : ", serviceInfo.offlineForms);
      let newForms = serviceInfo.offlineForms.filter(
        (form) => form.formId !== id
      );
      console.log("newforms are : ", newForms);
      newForms = newForms.map((form, i) => {
        return { ...form, position: i + 1 };
      });
      setServiceInfo({ ...serviceInfo, offlineForms: newForms });
    } else if (type === "inboundForm") {
      console.log(ToBeDeletedForm);
      console.log("old forms are : ", serviceInfo.ddiForms);
      let newForms = serviceInfo.ddiForms.filter((form) => form.formId !== id);
      console.log("newforms are : ", newForms);
      newForms = newForms.map((form, i) => {
        return { ...form, position: i + 1 };
      });
      setServiceInfo({ ...serviceInfo, ddiForms: newForms });
    } else if (type === "outboundForm") {
      console.log(ToBeDeletedForm);
      console.log("old forms are : ", serviceInfo.callLineForms);
      let newForms = serviceInfo.callLineForms.filter(
        (form) => form.formId !== id
      );
      console.log("newforms are : ", newForms);
      newForms = newForms.map((form, i) => {
        return { ...form, position: i + 1 };
      });
      setServiceInfo({ ...serviceInfo, callLineForms: newForms });
    }
    setShowRemoveModal(false);
  }
  function handleEditForm(
    formType,
    { formId, formName, position, number, name }
  ) {
    if (formType === "inboundForm") {
      console.log("form name :", formName, "form id :", formId);

      // need to compute the lineValues for each "number" that this form has

      const inputString = number;
      const valuesArray = inputString.split(", ").map(Number);

      const resultArray = valuesArray.map((value) => {
        const foundOption = inboundVdnOptions.find(
          (option) => option.value === value
        );
        return {
          value,
          label: foundOption ? foundOption.label : "Label not found",
        };
      });

      console.log(resultArray);

      console.log(number);
      setModals({
        ...modals,
        [formType]: {
          ...modals[formType],
          show: true,
          editing: true,
          value: { id: formId, label: formName },
          toBeEdited: {
            id: formId,
            label: formName,
            position: position,
            number: number,
          },
          number: resultArray,
        },
      });
    } else if (formType === "outboundForm") {
      console.log("form name :", formName, "form id :", formId);
      console.log(name);

      // need to map these names to an array of objects with value and label
      // so that we can use them in the select

      console.log(outboundVdnOptions);

      const inputString = name;
      const namesArray = inputString.split(", ");

      const resultArray = namesArray.map((name) => {
        const foundOption = outboundVdnOptions.find(
          (option) => option.label === name
        );
        return foundOption ? { value: foundOption.value, label: name } : null;
      });

      console.log(resultArray.filter(Boolean));

      setModals({
        ...modals,
        [formType]: {
          ...modals[formType],
          show: true,
          editing: true,
          value: { id: formId, label: formName },
          toBeEdited: {
            id: formId,
            label: formName,
            position: position,
            number: number,
          },
          name: resultArray.filter(Boolean),
        },
      });
    } else {
      console.log("form name :", formName, "form id :", formId);
      console.log(number);

      setModals({
        ...modals,
        [formType]: {
          ...modals[formType],
          show: true,
          editing: true,
          value: { id: formId, label: formName },
          toBeEdited: { id: formId, label: formName, position: position },
        },
      });
    }
  }

  function handleClose(formType) {
    console.log("closing: ", formType);
    setModals({
      ...modals,
      [formType]: {
        ...modals[formType],
        show: false,
        editing: false,
        value: { id: "", label: "" },
      },
    });
  }
  const handleSaveService = () => {
    setLoading(true);
    api.updateServiceById(serviceInfo).then((response) => {
      console.log(response);

      if (response.data.statusCode == 400 || response.data.statusCode == 500) {
        setShowErrorSnackbar({ show: true, message: response.data.message });
        setLoading(false);
      } else if (response.data.statusCode == 500) {
        setShowErrorSnackbar({ show: true, message: response.data.message });
        setLoading(false);
      } else {
        console.log("finished updating");
        setServiceInfo(response.data.object);

        api
          .getUserById(response.data.object.modifiedByUserId)
          .then((response) => {
            setModifiedUser(response.data.object.name);
            console.log(response.data.object);
          });
        setLoading(false);
        setShowConfirmationMessage(true);
      }
    });
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteServiceSnackbar, setDeleteServiceSnackbar] = useState({
    show: false,
    severity: "success",
  });

  const navigate = useNavigate();

  function removeServiceFromState(inputServices, targetId) {
    let services = cloneDeep(inputServices);
    for (let i = 0; i < services.length; i++) {
      if (services[i].serviceId == targetId) {
        //found the target service and deleting it
        console.log("found the target service and deleting it", targetId);
        services.splice(i, 1);
        break;
      } else {
        services[i] = {
          ...services[i],
          subServices: removeServiceFromState(
            services[i].subServices,
            targetId
          ),
        };
      }
    }
    console.log("new services after delete", services);
    return services;
  }

  const handleDeleteService = () => {
    // TODO: Delete the service

    api.deleteServiceById(params.id).then((response) => {
      console.log(response);
      if (response.data.statusCode == 400 || response.status == 202) {
        setShowErrorSnackbar({ show: true, message: response.data.message });
      } else {
        setDeleteServiceSnackbar({ ...deleteServiceSnackbar, show: true });
        let targetId = parseInt(params.id);
        let newServices = removeServiceFromState(servicesResponse, targetId);
        setServicesResponse(newServices);
        setTimeout(() => {
          navigate("/services");
        }, 1500);
      }
      setShowDeleteModal(false);
    });
  };

  return (
    <div className="main-content">
      {isLoading ? <Loading /> : ""}
      <h6 className="main-content__title">
        {serviceInfo.name + " " + strings[pageTitle][language].mainContentTitle}{" "}
      </h6>
      <div style={{ borderBottom: "1px solid black", marginLeft: "1em" }}></div>
      <div class="service-details-grid">
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].name}
        </div>
        <div class="grid-item">{serviceInfo.name}</div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].uamId}
        </div>
        <textarea
          class="grid-item"
          style={{ width: "100%" }}
          value={serviceInfo.uamServiceId}
          onChange={(e) => {
            //console.log(e.target.value);
            setServiceInfo({
              ...serviceInfo,
              uamServiceId: e.target.value,
            });
          }}
        ></textarea>
        {/*<div class="grid-item">{serviceInfo.uamServiceId}</div>*/}
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].activeFromTo}
        </div>
        <div class="grid-item">
          {serviceInfo.validFrom + " - " + serviceInfo.validTo}
        </div>
      </div>
      <p className="main-content__title">
        {strings[pageTitle][language].serviceAssignment}
      </p>

      <div
        class="service-details-grid"
        style={{
          borderBottom: "1px solid black",
          paddingBottom: "1em",
          marginBottom: "0",
          width: "60%",
        }}
      >
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].teamAccess}
        </div>
        {/* <div class="grid-item">Team selector here</div> */}
        <div class="grid-item">
          <Tags
            teams={serviceInfo.teams}
            handleSelectedTeams={(selectedTeams) => {
              setServiceInfo({ ...serviceInfo, teams: selectedTeams });
            }}
          />
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].teamsInherit}
        </div>
        <div class="grid-item">
          <input
            type="checkbox"
            name=""
            id=""
            checked={serviceInfo.teamsInherited}
            onChange={(event) => {
              setServiceInfo({
                ...serviceInfo,
                teamsInherited: event.target.checked,
              });
            }}
          />
        </div>
      </div>

      <div class="service-details-grid" style={{ marginTop: "0" }}>
        <div class="grid-item"></div>
        <div class="grid-item" style={{ width: "100%" }}>
          <div className="offline-form-buttons">
            <button
              className="button-round"
              style={{ alignSelf: "flex-end", marginLeft: "auto" }}
              onClick={() => handleAddForm("offlineForm")}
            >
              {strings[pageTitle][language].add}
            </button>
          </div>
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].offlineForms}
        </div>
        {/* <div class="grid-item">No forms found !</div> */}

        <table>
          <tr>
            <th>{strings[pageTitle][language].formName}</th>
            <th>{strings[pageTitle][language].editRemove}</th>
          </tr>

          {serviceInfo.offlineForms &&
            serviceInfo.offlineForms.sort(sortFormPositions).map((form) => {
              return (
                <tr>
                  <td>{form.formName}</td>
                  <td>
                    <div className="d-flex justify-content-end gap-2 align-items-center">
                      <ArrowUpward
                        sx={{ cursor: "pointer" }}
                        onClick={() =>
                          changeFormPosition(form.formId, "offlineForm", "up")
                        }
                      />
                      <ArrowDownward
                        sx={{ cursor: "pointer" }}
                        onClick={() =>
                          changeFormPosition(form.formId, "offlineForm", "down")
                        }
                      />

                      <FaEdit
                        size={"1.25em"}
                        className="icon-btn"
                        onClick={() => handleEditForm("offlineForm", form)}
                      />
                      <RiDeleteBin6Fill
                        size={"1.25em"}
                        className="icon-btn"
                        onClick={() => {
                          setShowRemoveModal(true);
                          setToBeDeletedForm({
                            type: "offlineForm",
                            id: form.formId,
                          });
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>

        <div class="grid-item"></div>
        <div class="grid-item" style={{ width: "100%" }}>
          <div className="offline-form-buttons">
            <button
              className="button-round"
              style={{ alignSelf: "flex-end", marginLeft: "auto" }}
              onClick={() => handleAddForm("inboundForm")}
            >
              {strings[pageTitle][language].add}
            </button>
          </div>
        </div>
        <div class="grid-item" className="grid-item-list">
          {strings[pageTitle][language].inboundCalls}
        </div>
        {/* <div class="grid-item">No forms found !</div> */}
        <table>
          <tr>
            <th>{strings[pageTitle][language].formName}</th>
            <th>{strings[pageTitle][language].inboundLineName}</th>
            <th>{strings[pageTitle][language].remove}</th>
          </tr>

          {serviceInfo.ddiForms &&
            serviceInfo.ddiForms.sort(sortFormPositions).map((form) => {
              return availableVdns === undefined ? (
                <isLoading></isLoading>
              ) : (
                <tr>
                  <td>{form.formName}</td>
                  <td>
                    {(() => {
                      const desiredIds = form.number.split(", ");
                      // FOR A SINGLE NUMBER
                      /*console.log(form.number);
                      console.log(availableVdns);
                      const foundObject = availableVdns.find(
                        (obj) => obj.inboundVdnId == form.number
                      );
                      console.log(foundObject);
                      return foundObject ? foundObject.name : "Not Found";*/

                      // FOR MULTIPLE NUMBERS

                      const desiredObjects = availableVdns.filter((vdn) => {
                        for (const desiredId of desiredIds) {
                          if (desiredId == vdn.inboundVdnId) {
                            return true;
                          }
                        }
                        return false;
                      });

                      console.log(desiredObjects);
                      let desiredObjectsString = "";
                      desiredObjects.forEach((obj, i, arr) => {
                        desiredObjectsString += obj.name;

                        if (i !== arr.length - 1) {
                          desiredObjectsString += ", ";
                        }
                      });
                      return desiredObjectsString;
                    })()}
                  </td>
                  <td>
                    <div className="d-flex justify-content-end gap-2 align-items-center">
                      <FaEdit
                        size={"1.25em"}
                        className="icon-btn"
                        onClick={() => {
                          console.log(form);
                          handleEditForm("inboundForm", form);
                        }}
                      />
                      <RiDeleteBin6Fill
                        size={"1.25em"}
                        className="icon-btn"
                        onClick={() => {
                          setShowRemoveModal(true);
                          setToBeDeletedForm({
                            type: "inboundForm",
                            id: form.formId,
                          });
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>

        <div class="grid-item"></div>
        <div class="grid-item" style={{ width: "100%" }}>
          <div className="offline-form-buttons">
            <button
              className="button-round"
              style={{ alignSelf: "flex-end", marginLeft: "auto" }}
              onClick={() => handleAddForm("outboundForm")}
            >
              {strings[pageTitle][language].add}
            </button>
          </div>
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].outboundCalls}
        </div>
        {/* <div class="grid-item">No forms found !</div> */}
        <table>
          <tr>
            <th>{strings[pageTitle][language].formName}</th>
            <th>{strings[pageTitle][language].line}</th>
            <th>{strings[pageTitle][language].remove}</th>
          </tr>

          {serviceInfo.callLineForms &&
            serviceInfo.callLineForms.map((form) => {
              return (
                <tr>
                  <td>{form.formName}</td>
                  <td>{form.name}</td>
                  <td>
                    <div className="d-flex justify-content-end gap-2">
                      <FaEdit
                        size={"1.25em"}
                        className="icon-btn"
                        onClick={() => {
                          console.log(form);
                          handleEditForm("outboundForm", form);
                        }}
                      />
                      <RiDeleteBin6Fill
                        size={"1.25em"}
                        className="icon-btn"
                        onClick={() => {
                          setShowRemoveModal(true);
                          setToBeDeletedForm({
                            type: "outboundForm",
                            id: form.formId,
                          });
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
      <p>
        {strings[pageTitle][language].lastEdited +
          serviceInfo.modified +
          strings[pageTitle][language].byUser}{" "}
        {modifiedUser}
      </p>
      <div style={{ borderBottom: "1px solid black", marginLeft: "1em" }}></div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        <button
          className="button-round"
          style={{
            alignSelf: "flex-end",
            margin: "1em",
            color: "red",
            borderColor: "red",
          }}
          onClick={() => {
            setShowDeleteModal(true);
          }}
        >
          {strings[pageTitle][language].delete}
        </button>
        <button
          className="button-round"
          style={{ alignSelf: "flex-end", margin: "1em" }}
          onClick={handleSaveService}
        >
          {strings[pageTitle][language].save}
        </button>
      </div>

      <Modal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].confirmDeleteModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {strings[pageTitle][language].confirmDeleteModalBody}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setShowDeleteModal(false);
            }}
          >
            {strings[pageTitle][language].cancel}
          </Button>
          {params.id && (
            <Button variant="danger" onClick={handleDeleteService}>
              {strings[pageTitle][language].delete}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={deleteServiceSnackbar.show}
        autoHideDuration={3000}
        onClose={() =>
          setDeleteServiceSnackbar({ ...deleteServiceSnackbar, show: false })
        }
      >
        <Alert severity={"success"}>
          {strings[pageTitle][language].deleteServiceConfirm}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={showConfirmationMessage}
        autoHideDuration={3000}
        onClose={() => setShowConfirmationMessage(false)}
      >
        <Alert severity={"success"}>
          {strings[pageTitle][language].successfullySaved}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={showConfirmationMessage}
        autoHideDuration={3000}
        onClose={() => setShowConfirmationMessage(false)}
      >
        <Alert severity={"success"}>
          {strings[pageTitle][language].successfullySaved}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={showErrorSnackbar.show}
        autoHideDuration={3000}
        onClose={() =>
          setShowErrorSnackbar({ ...showErrorSnackbar, show: false })
        }
      >
        <Alert severity={"error"}>{showErrorSnackbar.message}</Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={showInvalidVdnSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowInvalidVdnSnackbar(false)}
      >
        <Alert severity={"error"}>
          {strings[pageTitle][language].invalidVdn}
        </Alert>
      </Snackbar>

      <Modal
        show={modals.offlineForm.show}
        onHide={() => handleClose("offlineForm")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].addOfflineModalTitle}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-1 justify-content-evenly">
            {/* <h5>Form name</h5> */}
            <Autocomplete
              onChange={(event, value) => {
                handleFormSelection("offlineForm", value);
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disablePortal
              id="combo-box-demo"
              // value={modals.offlineForm.value}
              defaultValue={modals.offlineForm.value}
              options={
                AvailableForms
                  ? AvailableForms.map((form) => {
                      return {
                        id: form.formId,
                        label: form.name,
                      };
                    })
                  : []
              }
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={strings[pageTitle][language].formName}
                />
              )}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => handleClose("offlineForm")}>
            {strings[pageTitle][language].cancel}
          </Button>
          <Button
            variant="primary"
            onClick={() => handleAddFormToService("offlineForm")}
          >
            {strings[pageTitle][language].ok}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modals.offlineForm.show}
        onHide={() => handleClose("offlineForm")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].addOfflineModalTitle}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-1 justify-content-evenly">
            {/* <h5>Form name</h5> */}
            <Autocomplete
              onChange={(event, value) =>
                handleFormSelection("offlineForm", value)
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              disablePortal
              id="combo-box-demo"
              // value={modals.offlineForm.value}
              defaultValue={modals.offlineForm.value}
              options={
                AvailableForms
                  ? AvailableForms.map((form) => {
                      return {
                        id: form.formId,
                        label: form.name,
                      };
                    })
                  : []
              }
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={strings[pageTitle][language].formName}
                />
              )}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => handleClose("offlineForm")}>
            {strings[pageTitle][language].cancel}
          </Button>
          <Button
            variant="primary"
            onClick={() => handleAddFormToService("offlineForm")}
          >
            {strings[pageTitle][language].ok}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modals.inboundForm.show}
        onHide={() => handleClose("inboundForm")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].addInboundModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-1 justify-content-evenly">
            <Select
              options={inboundVdnOptions}
              isMulti={true}
              onChange={(value) => {
                //changeSelectedTeam(value, user, "admin");
                const values = value.map((item) => item.value);
                const result = values.join(", ");

                setselectedVdn(result);
                console.log(result);
              }}
              defaultValue={modals.inboundForm.number}
            ></Select>
          </div>
          <div className="d-flex gap-1 justify-content-evenly">
            {/* <h5>Form name</h5> */}
          </div>
          <div
            className="d-flex gap-1 justify-content-evenly"
            style={{ paddingTop: 10 }}
          >
            <Autocomplete
              defaultValue={modals.inboundForm.value}
              disablePortal
              id="combo-box-demo"
              onChange={(event, value) =>
                handleFormSelection("inboundForm", value)
              }
              options={
                AvailableForms
                  ? AvailableForms.map((f) => ({
                      id: f.formId,
                      label: f.name,
                    }))
                  : []
              }
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={strings[pageTitle][language].formName}
                />
              )}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => handleClose("inboundForm")}>
            {strings[pageTitle][language].cancel}
          </Button>
          <Button
            variant="primary"
            onClick={() => handleAddFormToService("inboundForm")}
          >
            {strings[pageTitle][language].ok}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modals.outboundForm.show}
        onHide={() => handleClose("outboundForm")}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].addOutboundModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-1 justify-content-evenly">
            {/* <h5>Form name</h5> */}
            <Select
              options={outboundVdnOptions}
              isMulti={true}
              onChange={(value) => {
                //changeSelectedTeam(value, user, "admin");

                //TODO: CHECK IF THIS WORKS PROPERLY

                const values = value.map((item) => item.label);
                const result = values.join(", ");

                setselectedVdn(result);
                console.log(result);

                //setselectedVdn(result);
              }}
              defaultValue={modals.outboundForm.name}
            ></Select>
          </div>
          <div
            className="d-flex gap-1 justify-content-evenly"
            style={{ paddingTop: 10 }}
          >
            {/* <h5>Form name</h5> */}
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={
                AvailableForms
                  ? AvailableForms.map((f) => ({
                      id: f.formId,
                      label: f.name,
                    }))
                  : []
              }
              sx={{ width: 300 }}
              onChange={(event, value) =>
                handleFormSelection("outboundForm", value)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={strings[pageTitle][language].formName}
                />
              )}
              defaultValue={modals.outboundForm.value}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => handleClose("outboundForm")}>
            {strings[pageTitle][language].cancel}
          </Button>
          <Button
            variant="primary"
            onClick={() => handleAddFormToService("outboundForm")}
          >
            {strings[pageTitle][language].ok}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRemoveModal}
        onHide={() => {
          setShowRemoveModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].confirmationMessage}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {strings[pageTitle][language].removeFormExplanation}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setShowRemoveModal(false);
            }}
          >
            {strings[pageTitle][language].no}
          </Button>
          <Button variant="danger" onClick={() => handleRemoveForm()}>
            {strings[pageTitle][language].yes}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ServiceInfo;
